import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CategoryType {
  id: string;
  categoriesTypeName: string;
}

interface CategoryTypeState {
  categoryTypes: CategoryType[];
  needRefresh: boolean;
}

const initialState: CategoryTypeState = {
  categoryTypes: [],
  needRefresh: true,
};

const categoryTypeSlice = createSlice({
  name: "categoryType",
  initialState,
  reducers: {
    setCategoryTypes: (state, action: PayloadAction<CategoryType[]>) => {
      state.categoryTypes = action.payload;
      state.needRefresh = false;
    },
    setCategoryTypeNeedRefresh: (state, action: PayloadAction<boolean>) => {
      state.needRefresh = action.payload;
    },
  },
});

export const { setCategoryTypes, setCategoryTypeNeedRefresh } =
  categoryTypeSlice.actions;
export default categoryTypeSlice.reducer;
